import React, { memo } from 'react';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import getImagePath from 'utils/get-image-path';

export const StyledLogo = styled.div`
  position: absolute;
  top: ${({ isEPGOpen }) => scaleSize(isEPGOpen ? 10 : 40)}px;
  right: ${({ isEPGOpen }) => scaleSize(isEPGOpen ? 10 : 40)}px;
  width: ${({ isEPGOpen }) => scaleSize(isEPGOpen ? 30 : 100)}px;
  height: ${({ isEPGOpen }) => scaleSize(isEPGOpen ? 30 : 100)}px;
  background: url(${({ logo }) => logo}) no-repeat center;
  background-size: contain;
`;

const ChannelLogo = ({ channelMetadata = {}, isEPGOpen }) => {
  const { hideLogo, logoUrl } = channelMetadata;

  if (hideLogo) return null;

  return (
    <StyledLogo
      isEPGOpen={isEPGOpen}
      logo={getImagePath(logoUrl, scaleSize(100), scaleSize(100))}
    />
  );
};

export default memo(ChannelLogo);
